export default __webpack_public_path__ + "static/media/Onyx.57a9183d.svg";